import { FormErrorMessage } from '@ksyos/design-system';
import { Link } from '@ksyos/router';
import { translateKey } from '../../../translate';

export function FeedbackForDuplicates(props: { error: string; id: string }) {
    if (props.error) {
        return (
            <FormErrorMessage>
                {props.error}
                <Link to={`/patients/${props.id}`}>{translateKey('patient.patient').toLowerCase()}</Link>
            </FormErrorMessage>
        );
    } else {
        return null;
    }
}
